import { __read } from "tslib";
import React, { useLayoutEffect, useState, useRef } from 'react';
import { fitText } from './utils';
var RulerLabel = function (_a) {
    var dx = _a.dx, dy = _a.dy, children = _a.children, orientation = _a.orientation, maxDimension = _a.maxDimension;
    var textRef = useRef(null);
    var _b = __read(useState(false), 2), isTruncated = _b[0], setTextTruncate = _b[1];
    useLayoutEffect(function () {
        if (maxDimension && textRef.current) {
            var text = children ? children.toString() : '';
            if (text) {
                var isTruncated_1 = fitText(textRef.current, text, maxDimension).isTruncated;
                setTextTruncate(isTruncated_1);
            }
        }
    }, [maxDimension, children]);
    return (React.createElement("g", null,
        React.createElement("text", { "data-elementid": orientation + "-ruler-label", ref: textRef, dx: dx, dy: dy }, children),
        isTruncated && React.createElement("title", { "data-testid": "ruler-label-title" }, children)));
};
export default RulerLabel;
